import { render, staticRenderFns } from "./BackupsList.vue?vue&type=template&id=3fdfb0e6&"
import script from "./BackupsList.vue?vue&type=script&lang=js&"
export * from "./BackupsList.vue?vue&type=script&lang=js&"
import style0 from "./BackupsList.vue?vue&type=style&index=0&id=3fdfb0e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports